import { render, staticRenderFns } from "./Enrolar.vue?vue&type=template&id=31c4b2e6"
import script from "./Enrolar.vue?vue&type=script&lang=js"
export * from "./Enrolar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports